module.exports = __webpack_public_path__ + "static/media/DOGE-BRL.6d04ce46.svg";